import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetail: [],
      timeZone: [],
      roles: ["Community Manager", "Distributor", "System Admin", "User"],
      userID: "",
      customerID: "default",
      customerName: "",
      time: "default",
      timeSelected: "",
      name: "",
      description: "",
      role: "default",
      email: "",
      password: "",
      confpassword: "",
      realTimeValidation: true,
      realTimeUserNameValidation: true,
      emailVerification: "",
      customerID_error: false,
      time_error: false,
      name_error: false,
      role_error: false,
      email_error: false,
      emailformat_error: false,
      password_error: false,
      passwordlength_error: false,
      confpassword_error: false,
    };
    this.formSubmit = false;
  }
  async componentDidMount() {
    console.log(this.props.match.params.id);
    let userId = this.props.match.params.id;
    this.setState({ userID: userId });
    //Get all customer id
    this.props.setLoadingPageAction(true);

    try {
      const userDetail = await axios.get(
        `${apiHost}/api/Auth/UpdateUsers/${userId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ userDetail: userDetail.data });
      this.setState({
        customerID: userDetail.data.customerId,
        customerName: userDetail.data.customerName,
        description: userDetail.data.description,
        // timeSelected:userDetail.data.timezone_City,
        time: userDetail.data.timeZoneId,
        name: userDetail.data.userName,
        role: userDetail.data.userType,
        email: userDetail.data.email,
        emailVerification: userDetail.data.email,
      });
      console.log("user id", userDetail.data);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    //   Get all Time zone

    this.props.setLoadingPageAction(true);

    try {
      const timeZone = await axios.get(
        `${apiHost}/api/Customer/GetAllTimeZone`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ timeZone: timeZone.data });
      console.log("timedfgdfgdZone ", timeZone.data);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    //Get all Roles
    this.props.setLoadingPageAction(true);

    try {
      const roles = await axios.get(`${apiHost}/api/auth/AllRoles`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      this.setState({ roles: roles.data });
      console.log("roles ", roles.data);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }
  handleCustomeridChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "default") {
      this.setState({ customerID_error: true });
    } else {
      this.setState({ customerID_error: false });
    }
    this.setState({ customerID: e.target.value });
  }
  handleTimeChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "default") {
      this.setState({ time_error: true });
    } else {
      this.setState({ time_error: false });
    }
    this.setState({ time: e.target.value, timeSelected: e.target.value });
  }
  handleNameChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
    }
    this.setState({ name: e.target.value });
  }
  handleRoleChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "default") {
      this.setState({ role_error: true });
    } else {
      this.setState({ role_error: false });
    }
    this.setState({ role: e.target.value });
  }
  handleEmailChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      // this.setState({emailformat_error:false})
      this.setState({ email_error: true });
    } else if (!e.target.value.match(mailformat)) {
      // this.setState({emailformat_error:true})
      this.setState({ email_error: false });
    } else {
      // this.setState({emailformat_error:false})
    }
    this.setState({ email: e.target.value });
  }
  handlePasswordChange(e) {
    console.log("e.target.value", e.target.value);
    // if(e.target.value=='' ){
    //     this.setState({passwordlength_error:false})

    //     this.setState({password_error:true})

    // }else
    // if (e.target.value.length < 6 || e.target.value.length > 15) {
    //   this.setState({ password_error: false });
    //   this.setState({ passwordlength_error: true });
    // } else {
    //   this.setState({ passwordlength_error: false });
    // }
    this.setState({ password: e.target.value });
  }
  handleConfirmPasswordChange(e) {
    if (e.target.value !== this.state.password) {
      this.setState({ confpassword_error: true });
    } else {
      this.setState({
        confpassword_error: false,
        confpassword: e.target.value,
      });
    }
  }
  async handleSubmit() {
    this.formSubmit = true;
    if (this.state.customerID == "default") {
      this.setState({ customerID_error: true });
      this.formSubmit = false;
    }
    if (this.state.time == "default") {
      this.setState({ time_error: true });
      this.formSubmit = false;
    }
    if (this.state.name == "") {
      this.setState({ name_error: true });
      this.formSubmit = false;
    }
    if (this.state.role == "default") {
      this.setState({ role_error: true });
      this.formSubmit = false;
    }
    if (this.state.email == "") {
      this.setState({ email_error: true });
      this.formSubmit = false;
    } else if (!this.state.realTimeValidation) {
      this.formSubmit = false;
    }
    // if(this.state.password==""){
    //     this.setState({password_error:true})
    //     this.setState({formSubmit:false})

    // } else if(this.state.confpassword==""){
    //     this.setState({confpassword_error:true})
    //     this.setState({formSubmit:false})
    // }

    if (this.formSubmit) {
      // console.log("apiobj",apiObj);
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/auth/Update`,
          {
            Id: this.state.userID,
            UserName: this.state.name,
            Description: this.state.description,
            Password: this.state.password,
            CustomerId: this.state.customerID,
            TimezoneId: this.state.time,
            Email: this.state.email,
            UserType: [this.state.role],
            dbUpdated: this.state.userDetail.dbUpdated,
            dbCreated: this.state.userDetail.dbCreated,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        console.log("customer id", response.data);
        // this.props.history.push('/users')
        this.props.history.goBack();
        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          if (e.response.data.statusCode == "1") {
            this.props.setErrorMessageAction(`${e}`);
          }
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  }
  handleDescription = (e) => {
    console.log("e.target.value", e.target.value);
    this.setState({ description: e.target.value });
  };
  realTimeUserValidation = async (e) => {
    if (e.target.value != this.state.emailVerification) {
      try {
        let response = await axios.get(
          `${apiHost}/api/Auth/IsEmailExist?Email=${encodeURIComponent(e.target.value)}&userId=${encodeURIComponent(this.state.userID)}`,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        console.log("response", response.data);
        this.setState({ realTimeValidation: true });
      } catch (e) {
        this.setState({ realTimeValidation: false });

        console.log(
          `Axios request failed.Error logged on Realtime User Check${e}`
        );
      }
    }
  };

  realTimeUserNameValidation = async (e) => {
      try {
        let response = await axios.get(
          `${apiHost}/api/Auth/IsUserExist?userName=${encodeURIComponent(e.target.value)}&userId=${encodeURIComponent(this.state.userID)}`, 
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        console.log("response", response.data);
        this.setState({ realTimeUserNameValidation: true});
      } catch (e) {
        this.setState({ realTimeUserNameValidation: false });

        console.log(
          `Axios request failed.Error logged on Realtime User Check${e}`
        );
      }
    };
  
  render() {
    console.log("this.state.timeSelected", this.state.timeSelected);
    return (
      <div>
        <Layout>
          <Helmet>
            <title>Edit User </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>Edit User</h2>
              <h6>edit </h6>
              <hr></hr>
              <Form>
                <Form.Group
                  as={Row}
                  controlId="exampleForm.HorizontalControlSelect1"
                >
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Customer ID</span>
                  </Form.Label>
                  <Col sm={10}>
                    <h6> {this.state.customerName}</h6>
                    <p
                      style={
                        this.state.customerID_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Customer field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  controlId="exampleForm.HorizontalControlSelect1"
                >
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Time Zone</span>
                  </Form.Label>
                  <Col sm={10}>
                    {console.log("timeeeeeeeeeeee", this.state.time)}
                    <Form.Control
                      as="select"
                      value={this.state.time}
                      onChange={this.handleTimeChange.bind(this)}
                    >
                      <option value="default">Select Time Zone</option>

                      {this.state.timeZone.map((time, index) => {
                        return (
                          <option value={time.timeZonesId}>
                            {time.timeZoneCity}
                            {console.log("timeeeeeeeeeeee", time.timeZoneId)}
                          </option>
                        );
                      })}
                    </Form.Control>
                    <p
                      style={
                        this.state.time_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Time Zone field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input">Name</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      value={this.state.name}
                      onChange={this.handleNameChange.bind(this)}
                      onBlur={(e) => {
                        this.realTimeUserNameValidation(e);
                      }}
                    />
                    <p
                      style={
                        this.state.name_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Name field is required.
                    </p>
                    {this.state.userName != "" && (
                      <React.Fragment>
                        <p
                          style={
                            !this.state.realTimeUserNameValidation
                              ? { color: "#a94442", fontSize: "14px" }
                              : { display: "none" }
                          }
                        >
                          User already exist
                        </p>
                      </React.Fragment>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlaintextArea">
                  <Form.Label column sm="2">
                    <span style={{ float: "right" }}>Description</span>
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control
                      as="textarea"
                      value={this.state.description}
                      rows="3"
                      onChange={this.handleDescription}
                    />
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  controlId="exampleForm.HorizontalControlSelect1"
                >
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Role</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="select"
                      value={this.state.role}
                      onChange={this.handleRoleChange.bind(this)}
                    >
                      <option value="default">Select Role</option>
                      {this.state.roles.map((role, index) => {
                        return (
                          <option value={role.roleName}>{role.roleName}</option>
                        );
                      })}
                    </Form.Control>
                    <p
                      style={
                        this.state.role_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Role field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Email</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="email"
                      value={this.state.email}
                      onChange={(e) => {
                        this.handleEmailChange(e);
                        this.realTimeUserValidation(e);
                      }}
                    />
                    <p
                      style={
                        this.state.email_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Email field is required.
                    </p>
                    <p
                      style={
                        this.state.emailformat_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Email field is not a valid e-mail address.
                    </p>
                    {this.state.email != "" && (
                      <React.Fragment>
                        <p
                          style={
                            !this.state.realTimeValidation
                              ? { color: "#a94442", fontSize: "14px" }
                              : { display: "none" }
                          }
                        >
                          Username already in use
                        </p>
                      </React.Fragment>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Password</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      onChange={this.handlePasswordChange.bind(this)}
                    />
                    <p
                      style={
                        this.state.password_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Password field is required.
                    </p>
                    {/* <p
                      style={
                        this.state.passwordlength_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Password must be between 6 characters and 15
                      characters
                    </p> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Confirm Password</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      onChange={this.handleConfirmPasswordChange.bind(this)}
                    />
                    <p
                      style={
                        this.state.confpassword_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The password and confirmation password do not match.
                    </p>
                  </Col>
                </Form.Group>
                <div className="footer-menu">
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => {
                      // this.props.history.push("/users");
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  &nbsp;
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                    disabled={!this.state.realTimeUserNameValidation ||  !this.state.realTimeValidation}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditUser);
